<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="onCancel()">Cancel</ion-button>
        </ion-buttons>
        <ion-title>Register</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="page-content">
    <p *ngIf="proName">
        You've been invited to participate in GoGet.Fit and be supported by
        <span id="pro-name">{{ proName }}</span>.
    </p>

    <p>
        You can register now using the email <span id="email">{{ email }}</span>
    </p>

    <form class="new-form" [formGroup]="form">
        <div *ngIf="!hasInvite">
            <app-access-code-input
                formControlName="accessCode"
                (input)="onAccessCodeInput()"
                [isStudent]="isStudent"
            >
            </app-access-code-input>
        </div>

        <p class="validation-error" *ngIf="invalidAccessCode.value">
            That access code could not be found.
        </p>

        <label for="name">Full name</label>
        <input
            id="name"
            type="text"
            formControlName="fullName"
            (input)="onFullNameInput()"
        />

        <label for="chosen">What can we call you?</label>
        <input id="chosen" type="text" formControlName="chosenName" />

        <!-- Removed for now (see https://www.pivotaltracker.com/story/show/187486784/comments/241068456 -->
        <!--
        <div class="toggle-wrapper" *ngIf="!isStudent">
            <input
                id="wants-email-updates"
                type="checkbox"
                class="sliding-toggle"
                formControlName="wantsEmailUpdates"
            />
            <label for="wants-email-updates">
                Please sign me up to receive expert health and wellness content
                ideas from GoGet.Fit.
            </label>
        </div>
        -->

        <app-accept-terms-input
            formControlName="acceptTerms"
            *ngIf="showAcceptTerms"
        >
        </app-accept-terms-input>

        <section class="stacked-page-action-area">
            <ion-button
                type="submit"
                (click)="onSignUp()"
                [disabled]="!canSubmit"
            >
                Register
            </ion-button>
            <ion-button
                type="button"
                fill="outline"
                (click)="onCancel()"
                [disabled]="form.disabled"
            >
                Cancel
            </ion-button>
        </section>
    </form>
</ion-content>
